module.exports = __webpack_public_path__ + "media/images/motivation-6a0d98045a93213a7661c86fa2bd360f.svg";